document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', () => {
        const sc = window.scrollY;
        const header = document.querySelector('header');

        if (sc > 150) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    const topButton = document.querySelector('.top-button')
    if (topButton) {
        document.addEventListener('scroll', () => {
            const y = window.scrollY;

            if (y > 640) {
                topButton.classList.add('visible');
            } else {
                topButton.classList.remove('visible');
            }
        });
    }

    // DROPDOWN DESKTOP
    document.querySelectorAll('.menu-item-has-children').forEach(function(item) {
        if (window.innerWidth >= 1200) {
            let timeout;

            item.addEventListener('mouseenter', function() {
                clearTimeout(timeout);
                item.classList.add('is-open');
            });

            item.addEventListener('mouseleave', function() {
                timeout = setTimeout(function() {
                    item.classList.remove('is-open');
                }, 150); // petit délai pour laisser le temps à la souris de descendre
            });
        }
    });

    // NAVIGATION MOBILE
    const body = document.querySelector('body');
    const header = document.querySelector('header');
    const toggle = header?.querySelector('.menu-toggle');
    const hiddenText = toggle.querySelector('.visually-hidden');
    const nav = header?.querySelector('#site-navigation');

    if (!toggle || !nav) return;

    function openMenu() {
        nav.classList.add('is-open');
        body.classList.add('no-scroll');
        toggle.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
        nav.classList.remove('is-open');
        body.classList.remove('no-scroll');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
    }

    toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        expanded ? closeMenu() : openMenu();
        hiddenText.textContent = expanded ? 'Ouvrir le menu' : 'Fermer le menu';
    });

    document.addEventListener('click', (e) => {
        if (
            nav.classList.contains('is-open') &&
            !nav.contains(e.target) &&
            !toggle.contains(e.target)
        ) {
            closeMenu();
        }
    });

    // SOUS MENU MOBILE
    const menuItems = document.querySelectorAll('.main-menu > .menu-item-has-children > a');

	menuItems.forEach(link => {
		link.addEventListener('click', (e) => {
			if (window.innerWidth < 1200) {
				e.preventDefault();

				const parentLi = link.parentElement;
				const subMenu = parentLi.querySelector('.sub-menu');

				// Fermer tous les autres sous-menus
				document.querySelectorAll('.menu-item.submenu-open').forEach(openItem => {
					if (openItem !== parentLi) {
						openItem.classList.remove('submenu-open');
						const openSub = openItem.querySelector('.sub-menu');
						if (openSub) {
							openSub.style.maxHeight = null;
						}
					}
				});

				// Toggle celui qu'on vient de cliquer
				const isOpen = parentLi.classList.contains('submenu-open');
				parentLi.classList.toggle('submenu-open', !isOpen);

				if (subMenu) {
					subMenu.style.maxHeight = !isOpen ? "1000px" : null;
				}
			}
		});
	});

    // DROPDOWN PERSONAS DANS LA NAV PRINCIPALE
    const toggleBtn = document.querySelector('.dropdown-toggle');
    const dropdown = document.querySelector('.dropdown');

    toggleBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = dropdown.getAttribute('data-open') === 'true';
        dropdown.setAttribute('data-open', !isOpen);
        toggleBtn.setAttribute('aria-expanded', !isOpen);
    });

    document.addEventListener('click', (event) => {
        const isClickInside = dropdown.contains(event.target);
        if (!isClickInside) {
            dropdown.setAttribute('data-open', 'false');
            toggleBtn.setAttribute('aria-expanded', 'false');
        }
    });

    // SIDEBAR DE NAVIGATION
    (function () {
        // Exécuter uniquement sur le template voulu
        if (!document.body.classList.contains('page-template-page-sidebar')) return;

        const section = document.querySelector('.editor');
        const aside   = document.querySelector('aside');
        if (!section || !aside) return;

        // --------------------------
        // Utilitaires
        // --------------------------
        const slugCounts = new Map();
        function slugify(text) {
            return text
            .toLowerCase()
            .trim()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // retire accents
            .replace(/[^a-z0-9]+/g, '-')                     // non alphanum -> -
            .replace(/^-+|-+$/g, '')                         // trim -
            .replace(/-+/g, '-');                            // collapse
        }
        function uniqueId(prefix, text) {
            const base = slugify(text) || 'section';
            const key  = prefix + ':' + base;
            const n    = slugCounts.get(key) || 0;
            slugCounts.set(key, n + 1);
            return n ? `${prefix}-${base}-${n}` : `${prefix}-${base}`;
        }

        // --------------------------
        // Collecte & ID des titres
        // --------------------------
        // On s'intéresse aux h2 et h3 dans .editor, y compris h3 dans des colonnes
        const allHeadings = Array.from(section.querySelectorAll('h2:not(.bloc), h3:not(.bloc)'));
        if (!allHeadings.length) return;

        // Assigner un id unique si absent
        allHeadings.forEach(h => {
            if (!h.id) {
            const prefix = h.tagName === 'H2' ? 'h2' : 'h3';
            h.id = uniqueId(prefix, h.textContent);
            }
        });

        // --------------------------
        // Structuration H2 -> H3
        // --------------------------
        const toc = [];
        let currentH2 = null;
        allHeadings.forEach(h => {
            if (h.tagName === 'H2') {
            currentH2 = { id: h.id, text: h.textContent.trim(), children: [] };
            toc.push(currentH2);
            } else if (h.tagName === 'H3') {
            // rattacher au dernier H2 rencontré ; sinon, on crée une section "orphelin"
            if (!currentH2) {
                currentH2 = { id: uniqueId('h2', 'contenu'), text: 'Contenu', children: [] };
                toc.push(currentH2);
            }
            currentH2.children.push({ id: h.id, text: h.textContent.trim() });
            }
        });

        // --------------------------
        // Construction du sommaire (liste desktop)
        // --------------------------
        function buildListMenu() {
            const frag = document.createDocumentFragment();

            const title = document.createElement('p');
            title.id = 'sommaire';
            title.textContent = 'Accès rapides';
            frag.appendChild(title);

            const ulH2 = document.createElement('ul');
            ulH2.className = 'menu-h2';

            toc.forEach(h2 => {
            const li = document.createElement('li');
            const a  = document.createElement('a');
            a.href = `#${h2.id}`;
            a.textContent = h2.text;
            li.appendChild(a);

            if (h2.children.length) {
                const ulH3 = document.createElement('ul');
                ulH3.className = 'menu-h3';
                h2.children.forEach(h3 => {
                const li3 = document.createElement('li');
                const a3  = document.createElement('a');
                a3.href = `#${h3.id}`;
                a3.textContent = h3.text;
                li3.appendChild(a3);
                ulH3.appendChild(li3);
                });
                li.appendChild(ulH3);
            }
            ulH2.appendChild(li);
            });

            frag.appendChild(ulH2);
            return frag;
        }

        // --------------------------
        // Construction du sommaire (dropdown mobile)
        // --------------------------
        function buildDropdownMenu() {
            const frag = document.createDocumentFragment();

            const wrapper = document.createElement('div');
            wrapper.className = 'summary-dropdown';

            const btn = document.createElement('button');
            btn.className = 'summary-toggle';
            btn.id = 'sommaire';
            btn.type = 'button';
            btn.setAttribute('aria-expanded', 'false');

            const listId = 'summary-menu';
            btn.setAttribute('aria-controls', listId);
            btn.textContent = 'Sommaire';

            const ul = document.createElement('ul');
            ul.className = 'summary-menu';
            ul.id = listId;
            ul.hidden = true;

            toc.forEach(h2 => {
            const li = document.createElement('li');
            const a  = document.createElement('a');
            a.href = `#${h2.id}`;
            a.textContent = h2.text;
            li.appendChild(a);
            ul.appendChild(li);

            h2.children.forEach(h3 => {
                const subLi = document.createElement('li');
                subLi.className = 'submenu';
                const subA = document.createElement('a');
                subA.href = `#${h3.id}`;
                subA.textContent = '— ' + h3.text;
                subLi.appendChild(subA);
                ul.appendChild(subLi);
            });
            });

            // toggle
            btn.addEventListener('click', () => {
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', String(!expanded));
            ul.hidden = expanded;
            });

            // clic extérieur -> fermer
            document.addEventListener('click', (evt) => {
            if (!wrapper.contains(evt.target)) {
                btn.setAttribute('aria-expanded', 'false');
                ul.hidden = true;
            }
            });

            // clic item -> fermer
            ul.addEventListener('click', (evt) => {
            if (evt.target.closest('a')) {
                btn.setAttribute('aria-expanded', 'false');
                ul.hidden = true;
            }
            });

            wrapper.appendChild(btn);
            wrapper.appendChild(ul);
            frag.appendChild(wrapper);
            return frag;
        }

        // --------------------------
        // Rendu initial + responsive
        // --------------------------
        function renderTOC() {
            aside.innerHTML = '';
            const isMobile = window.innerWidth <= 992;
            aside.appendChild(isMobile ? buildDropdownMenu() : buildListMenu());
            mapLinks(); // re-mapper après rendu
        }

        // (re)map id -> <a> pour mise à jour "active"
        let linkById = new Map();
        function mapLinks() {
            linkById.clear();
            aside.querySelectorAll('a[href^="#"]').forEach(a => {
            const id = decodeURIComponent(a.getAttribute('href').slice(1));
            linkById.set(id, a);
            });
        }

        renderTOC();

        // Rebuild on resize (anti-rebond)
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(renderTOC, 150);
        }, { passive: true });

        // --------------------------
        // Suivi de section active (IntersectionObserver)
        // --------------------------
        // On observe H2 + H3 dans .editor
        const observed = allHeadings;

        // Seuils : on surligne quand ~15%–35% de l’élément est visible
        const io = new IntersectionObserver((entries) => {
            // Trier pour garder l'entrée la plus proche du haut du viewport visible
            const visible = entries
            .filter(e => e.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

            if (!visible.length) return;

            const activeEl = visible[0].target;
            const activeId = activeEl.id;

            // Clear états
            aside.querySelectorAll('li').forEach(li => li.classList.remove('active'));
            aside.querySelectorAll('a[aria-current="true"]').forEach(a => a.removeAttribute('aria-current'));

            // Activer lien correspondant (H3 OU H2)
            const a = linkById.get(activeId);
            if (a) {
            a.setAttribute('aria-current', 'true');
            const li = a.closest('li');
            if (li) li.classList.add('active');
            }
        }, {
            root: null,
            // On décale la zone d'intérêt autour de ~15% du viewport
            rootMargin: '-15% 0px -70% 0px',
            threshold: [0.15, 0.35]
        });

        observed.forEach(h => io.observe(h));

        // --------------------------
        // Amélioration UX : scroll doux
        // --------------------------
        aside.addEventListener('click', (evt) => {
            const a = evt.target.closest('a[href^="#"]');
            if (!a) return;
            const id = decodeURIComponent(a.getAttribute('href').slice(1));
            const target = document.getElementById(id);
            if (!target) return;

            evt.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + id); // ancre dans l’URL sans rechargement
        });

    })();

    // MODALE DE RECHERCHE 
    const openBtns = document.querySelectorAll('[data-open-search]');
    const closeBtn = document.querySelector('[data-close-search]');
    const modal = document.getElementById('search-modal');
    const modalFocusableSelectors = 'input, button, [tabindex]:not([tabindex="-1"])';
    let lastFocusedElement = null;

    if(modal) {
        
        function openModal(modal, opener) {
            lastFocusedElement = opener || document.activeElement;
            modal.classList.add('show');
            modal.removeAttribute('hidden');
            document.body.classList.add('no-scroll');
            const firstInput = modal.querySelector('input');
            if (firstInput) firstInput.focus();
            document.addEventListener('keydown', trapFocus);
        }

        function closeModal() {
            modal.classList.remove('show');
            modal.setAttribute('hidden', 'true');
            document.body.classList.remove('no-scroll');
            document.removeEventListener('keydown', trapFocus);
            console.log(lastFocusedElement);
            // Laisse le temps au DOM / CSS de se mettre à jour avant de rendre le focus
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
                setTimeout(() => lastFocusedElement.focus(), 0);
            }
        }

        function trapFocus(e) {
            const focusables = modal.querySelectorAll(modalFocusableSelectors);
            const first = focusables[0];
            const last = focusables[focusables.length - 1];

            if (e.key === 'Escape') {
                e.preventDefault();
                closeModal();
            }

            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

        openBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const modalId = btn.getAttribute('aria-controls');
                const modal = document.getElementById(modalId);
                openModal(modal, btn);
            });
        });
        closeBtn.addEventListener('click', closeModal);
    }

    // Liste déroulante des communes Sictom
    const input = document.getElementById('commune');
    const sictomInput = document.getElementById('sictom');
    const form = document.getElementById('form-commune');
    const listContainer = document.getElementById('autocomplete-list');
    let data = [];

    if (!input) return; // sécurité au cas où le champ n'existe pas

    // Charger le JSON
    fetch(`${window.location.origin}/wp-content/themes/trigone/assets/data/communes.json`)
        .then(response => response.json())
        .then(json => data = json)
        .catch(err => console.error("Erreur chargement JSON communes :", err));

    // Gestion de l'autocomplétion
    input.addEventListener('input', function () {
        const value = this.value.toLowerCase();
        listContainer.innerHTML = '';

        if (!value) return;

        const suggestions = data
            .filter(item =>
                item.commune.toLowerCase().includes(value) ||
                item.code_postal.toString().includes(value)
            )
            .slice(0, 10); // limiter à 10 résultats

        suggestions.forEach(item => {
            const div = document.createElement('div');
            div.textContent = `${item.commune} (${item.code_postal})`;
            div.addEventListener('click', () => {
                input.value = `${item.commune} (${item.code_postal})`;
                sictomInput.value = item.sictom;
                listContainer.innerHTML = '';
            });
            listContainer.appendChild(div);
        });
    });

    // Cacher la liste quand on clique ailleurs
    document.addEventListener('click', (e) => {
        if (e.target !== input) listContainer.innerHTML = '';
    });

    // Soumission du formulaire
    form.addEventListener('submit', function (e) {
        e.preventDefault();

        const sictom = sictomInput.value;
        if (!sictom) {
            alert("Veuillez sélectionner une commune dans la liste.");
            return;
        }

        // Association SICTOM : ID de page
        const pages = {
            "OUEST": 997,
            "EST": 999,
            "CENTRE": 1005,
            "SMCD": 1015,
            "SIDEL": 1003,
            "SUD-EST": 1001,
            "CONDOM": 1009,
            "GRAND-AUCH": 1007,
        };

        const pageId = pages[sictom];
        if (pageId) {
            window.location.href = `${window.location.origin}/?page_id=${pageId}`;
        } else {
            alert("Aucune page trouvée pour ce SICTOM.");
        }
    });
});